import Transformer from '@/transformers/transformer'

import moment from 'moment'
moment.locale('es-mx')

const supplyTransformer = function ({
  current_quantity:currentQuantity, is_approved: isApproved,
  iwarehouse_quantification_supply_id: iWarehouseQuantificationSupplyId,
  iwarehouse_supply_id: iWarehouseSupplyId, status,
  iwarehouse_supply_unit_cost: iWarehouseSupplyUnitCost,
  quantity_to_requested: quantityToRequest, supply_family: supplyFamily,
  supply_id: supplyId, supply_name: supplyName, supply_subfamily: supplySubFamily,
  supply_unit: supplyUnit, total_cost: totalCost, delivery_complete: deliveryComplete,
  quantity_physical_out: quantityPhysicalOut, supply_code: supplyCode,
  iwarehouse_output_extra_supply_id: extraSupplyId
}, extraOutputId) {
  return {
    currentQuantity: Number.parseFloat(currentQuantity).toFixed(6),
    isApproved,
    extraSupplyId,
    iWarehouseQuantificationSupplyId,
    quantificationSupplyIds: [iWarehouseQuantificationSupplyId],
    iWarehouseSupplyId,
    status,
    iWarehouseSupplyUnitCost,
    quantityToRequest: Number.parseFloat(quantityToRequest).toFixed(6),
    supplyFamily,
    supplyId,
    supplyName,
    supplySubFamily,
    supplyUnit,
    totalCost,
    extraOutputId,
    amountToBeReleased: (+quantityToRequest - +quantityPhysicalOut).toFixed(6),
    deliveryComplete,
    quantityPhysicalOut: Number.parseFloat(quantityPhysicalOut).toFixed(6),
    supplyCode
  }
}

export default class extraOutputsRequest extends Transformer {
  static fetch({
    last_update, added_date, affected_id: affectedId, affected_description: affectedDesc,
    affected_requisition_number: affectedRequisitionNumber, estimated_sale: estimatedSale,
    highway_name: highwayName, highway_section_id: highwaySectionId,
    highway_section_name: highwaySectionName, iwarehouse_id: iWarehouseId,
    iwarehouse_name: iWarehouseName, iwarehouse_quantification_id: iWarehouseQuantificationId,
    sinister_date_assignment, sinister_date_occurred,
    sinister_id: sinisterId, sinister_its_priority: sinisterItsPriority,
    sinister_its_urgent: sinisterItsUrgent, sinister_number: sinisterNumber,
    sinister_road_body: sinisterRoadBody, sinister_road_kilometer: sinisterRoadKilometer,
    sinister_road_meter: sinisterRoadMeter, sinister_type_of_job: sinisterTypeOfJob,
    status, supplies, sinister_road_id: sinisterRoadId, iwarehouse_output_extra_id: extraOutputId
  }) {
    return {
      affectedId,
      extraOutputId,
      affectedDesc,
      affectedRequisitionNumber,
      estimatedSale,
      highwayName,
      highwaySectionId,
      highwaySectionName,
      iWarehouseId,
      iWarehouseName,
      iWarehouseQuantificationId,
      sinisterId,
      sinisterItsPriority,
      sinisterItsUrgent,
      sinisterNumber,
      sinisterRoadBody,
      sinisterRoadKilometer,
      sinisterRoadMeter,
      sinisterTypeOfJob,
      status,
      sinisterToRelease:false,
      sinisterRoadId,
      showSupplies: false,
      supplies: supplies.length > 0 ? supplies.map((s) => supplyTransformer(s, extraOutputId)) : [], 
      addedDate: moment(added_date).format('DD/MM/YYYY'),
      lastUpdate: moment(last_update).format('DD/MM/YYYY'),
      sinisterDateAssignment: moment(sinister_date_assignment).format('DD/MM/YYYY'),
      sinisterDateOcurred: moment(sinister_date_occurred).format('DD/MM/YYYY'),
    }
  }
}


// WEBPACK FOOTER //
// ./src/transformers/catalog/warehouse/extraOutputsRequest.js